import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
@Component({
  selector: 'app-cheque-no',
  templateUrl: './../../../templates/forms/modals/dept-name-list.component.html',
})
export class DeptNameListComponent implements OnInit {
  @Input()
  config:any;

  @Input()
  modalShow: boolean = true;

  @Input()
  thirdParam: number;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  searchFields: any[] = ['BU_NAME','BU_NO'];
  public searchString;

  dataObj:any;

  deptNameList: any[] = [];


  constructor(public langService: LangService, private comService: CommonService) {

  }


  ngOnInit() {
    if(this.thirdParam == 2){
      this.comService.getBusinessUnits().subscribe(result => {
        this.deptNameList = result.body;
      });
    }else{
      this.comService.getBusinessDept().subscribe(result => {
        this.deptNameList = result.body;
      });
    }
    
  }

}
